
import HowToRegIcon from '@mui/icons-material/HowToReg';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';


const QAMgmt = {
  id: '12',
  title: 'QA Mgmt',
  type: 'group',
  role: 'PHARMA_OMS_QA',
  children: [
    {
              id: 'tasklist',
              title: 'My Task(s)',
              type: 'item',
              url: '/',
              bottomMenu:'MYTASKS',
              icon: FormatListNumberedIcon
            },
    // {
    //   id: 'designqaapproval',
    //   title: 'Design Review',
    //   type: 'item',
    //   url: '/',
    //   bottomMenu:'QA_DESIGN_APPROVAL',
    //   icon: HowToRegIcon
    // },
    // {
    //   id: 'sampleqaapproval',
    //   title: 'Sample Under QA Approval',
    //   type: 'item',
    //   url: '/',
    //   bottomMenu:'QA_SAMPLE_APPROVAL',
    //   icon: HowToRegIcon
    // },
  ]
};

export default QAMgmt;